import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProduct, getAllKits } from "../../reducer/actions";
import styles from "./EditKitModal.module.css";
import axios from "axios";

const EditKitModal = ({ kit, closeModal }) => {
  const dispatch = useDispatch();
  const allProducts = useSelector((state) => state.products);

  const [kitData, setKitData] = useState({
    name: kit.name,
    image: kit.image,
    price: kit.price || "",
    products: kit.products || [],
  });

  const [showConfirm, setShowConfirm] = useState(false);
  const [changes, setChanges] = useState({});
  const [showProductSelector, setShowProductSelector] = useState(false);
  const [selectedProductIndex, setSelectedProductIndex] = useState(null);
  const [successMessage, setSuccessMessage] = useState(false);

  useEffect(() => {
    dispatch(getProduct());
  }, [dispatch]);

  const handleReplaceProduct = (index) => {
    setSelectedProductIndex(index);
    setShowProductSelector(true);
  };

  const handleSelectProduct = (product) => {
    const updatedProducts = [...kitData.products];
    updatedProducts[selectedProductIndex] = {
      id: product.id,
      name: product.name,
      image: product.images[0],
      price: product.price,
      description: product.description,
    };
    setKitData({ ...kitData, products: updatedProducts });
    setShowProductSelector(false);
    setSelectedProductIndex(null);
  };

  const getChangedFields = () => {
    const modified = {};
    if (kit.name !== kitData.name) modified.name = kitData.name;
    if (kit.price !== kitData.price) modified.price = kitData.price;
    if (kit.image !== kitData.image) modified.image = kitData.image;

    const changedProducts = kitData.products.filter((p, i) => {
      const original = kit.products[i];
      return (
        !original ||
        original.id !== p.id ||
        original.name !== p.name ||
        original.price !== p.price ||
        original.image !== p.image ||
        original.description !== p.description
      );
    });

    if (changedProducts.length > 0) modified.products = changedProducts;

    return modified;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const modified = getChangedFields();

    if (Object.keys(modified).length === 0) {
      alert("No hay cambios para guardar.");
      return;
    }

    setChanges(modified);
    setShowConfirm(true);
  };

  const confirmChanges = async () => {
    try {
      await axios.put(
        `https://rezuma-back.onrender.com/kits/${kit.id}`,
        kitData
      );

      setSuccessMessage(true);
      setShowConfirm(false);

      // Refrescar kits después de guardar
      dispatch(getAllKits());

      // Cerrar mensaje de éxito luego de 2 segundos
      setTimeout(() => {
        setSuccessMessage(false);
        closeModal();
      }, 2000);
    } catch (error) {
      console.error(
        "Error al actualizar el kit:",
        error.response?.data || error.message
      );
    }
  };

  const cancelChanges = () => {
    setShowConfirm(false);
  };

  return (
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <h2>Editar Kit</h2>
        <form onSubmit={handleSubmit} className={styles.form}>
          <label>Nombre del Kit:</label>
          <input
            type="text"
            value={kitData.name}
            onChange={(e) => setKitData({ ...kitData, name: e.target.value })}
            className={styles.input}
          />

          <label>Precio:</label>
          <input
            type="text"
            value={kitData.price}
            onChange={(e) => setKitData({ ...kitData, price: e.target.value })}
            className={styles.input}
            placeholder="Ingrese el precio del kit"
          />

          <h3>Sopas del Kit:</h3>
          {kitData.products.map((product, index) => (
            <div key={index} className={styles.productRow}>
              <div className={styles.productInfo}>
                <p>
                  <strong>Sopa {index + 1}:</strong> {product.name}
                </p>
              </div>
              <button
                type="button"
                onClick={() => handleReplaceProduct(index)}
                className={styles.replaceButton}
              >
                Reemplazar con nueva Sopa
              </button>
            </div>
          ))}

          <div className={styles.buttons}>
            <button type="submit" className={styles.saveButton}>
              Guardar Cambios
            </button>
            <button
              type="button"
              onClick={closeModal}
              className={styles.closeButton}
            >
              Cerrar
            </button>
          </div>
        </form>
      </div>

      {/* ✅ MENSAJE DE ÉXITO */}
      {successMessage && (
        <div className={styles.successMessage}>
          <div className={styles.successContent}>
            <h3>✅ ¡Kit actualizado con éxito!</h3>
          </div>
        </div>
      )}

      {/* CONFIRMAR CAMBIOS */}
      {showConfirm && (
        <div className={styles.confirmModal}>
          <div className={styles.confirmContent}>
            <h3>¿Confirmar cambios?</h3>
            <ul>
              {changes.name && (
                <li>
                  <strong>Nombre:</strong> {changes.name}
                </li>
              )}
              {changes.price && (
                <li>
                  <strong>Precio:</strong> {changes.price}
                </li>
              )}
              {changes.products && (
                <li>
                  <strong>Productos modificados:</strong>
                  <ul>
                    {changes.products.map((p, i) => (
                      <li key={i}>
                        {p.name} - ${p.price}
                      </li>
                    ))}
                  </ul>
                </li>
              )}
            </ul>
            <div className={styles.buttons}>
              <button onClick={confirmChanges} className={styles.saveButton}>
                Aceptar
              </button>
              <button onClick={cancelChanges} className={styles.closeButton}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* SELECTOR DE SOPAS */}
      {showProductSelector && (
        <div className={styles.selectorModal}>
          <div className={styles.selectorContent}>
            <h3>Selecciona una nueva sopa:</h3>
            <ul className={styles.nameList}>
              {allProducts.map((product) => (
                <li
                  key={product.id}
                  onClick={() => handleSelectProduct(product)}
                  className={styles.nameItem}
                >
                  {product.name}
                </li>
              ))}
            </ul>
            <button
              onClick={() => setShowProductSelector(false)}
              className={styles.closeButton}
            >
              Cancelar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditKitModal;
